// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  functionsRegion: 'europe-west1',
  useEmulators: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBua-_caYLntFe74ZLicHlvh_blQjYU2zU',
    authDomain: 'orderingapp5.firebaseapp.com',
    projectId: 'orderingapp5',
    storageBucket: 'orderingapp5.appspot.com',
    messagingSenderId: '425637924987',
    appId: '1:425637924987:web:a2ea2ea5eb428523c512de',
    measurementId: 'G-JZZ30KY7GB',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
